import { CustomConverter, DateTimeConverter, JsonObject, JsonProperty, NotNull, Optional } from 'json-ts-mapper';

@JsonObject
export class CotationHistorique {
  constructor (
    id?: number,
    valeur?: number,
    idArticleLieuDepart?: number,
    datePublication?: Date
  ) {
    this.id = id as any;
    this.valeur = valeur as any;
    this.idArticleLieuDepart = idArticleLieuDepart as any;
    this.datePublication = datePublication as any;
  }

  @JsonProperty(Number)
  @NotNull
  id:number;

  @JsonProperty(Number)
  @Optional
  valeur?:number;

  @JsonProperty(Number)
  @NotNull
  idArticleLieuDepart:number;

  @JsonProperty(String)
  @CustomConverter(DateTimeConverter)
  @NotNull
  datePublication: Date;
}
